import axios from "axios";
import HashMap from "hashmap";
import { LogoutUserAction } from "./LoginRedux/Action";
import { startLoading, stopLoading } from "./Loader/Action";
import { API_TYPE } from "../constants";
let map = new HashMap();

export function makeApiCall(
  apiUrl,
  successCall,
  failureCall,
  methodName,
  reqBody,
  reqHeader,
  history,
  type = API_TYPE.OLD
) {
  let axiosBody = null;
  if (methodName === "GET") {
    axiosBody = {
      method: methodName,
      url: apiUrl,
      headers: reqHeader,
    };
  } else if (methodName === "POST") {
    axiosBody = {
      method: methodName,
      url: apiUrl,
      data: reqBody,
      headers: reqHeader,
    };
  }
  return async (dispatch) => {
    dispatch(startLoading());
    await axios(axiosBody)
      .then((response) => {
        dispatch(stopLoading());
        if (response.status >= 200 && response.status < 300) {
          if (type === API_TYPE.NEW) {
            if (response.data?.statusCode === 200) {
              dispatch(
                successCall(
                  type === API_TYPE.NEW
                    ? response.data?.responseData ?? response.data?.message
                    : response.data
                )
              );
            } else {
              dispatch(failureCall(response.data?.message));
            }
          } else {
            dispatch(successCall(response.data));
          }
        } else if (response.status === 401) {
        } else {
          const error = new Error(response.statusText);
          dispatch(failureCall(error));
          throw error;
        }
      })
      .catch((err) => {
        dispatch(stopLoading());
        if (err.response) {
          switch (err.response.status) {
            case 400:
              err = handleError(err, type);
              dispatch(failureCall(err));
              break;
            case 404:
              err = handleError(err, type);
              dispatch(failureCall(err));
              break;
            case 500:
              err = handleError(err, type);
              dispatch(failureCall(err));
              break;
            default:
              err = handleError(err, type);
              dispatch(failureCall(err));
              break;
          }
        } else if (history) {
          // Logout action will go here.
          dispatch(LogoutUserAction());
          history.push("/");
        } else {
          err = handleError(err, type);
          dispatch(failureCall(err));
        }
      });
  };
}

export function handleError(err, type) {
  let result = "Internal Server Error";
  if (err.response) {
    switch (err.response.status) {
      case 400:
      case 404:
      case 500:
        if (type === API_TYPE.NEW) {
          result = err?.response?.data?.message;
        } else if (typeof err.response.data === "object") {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
          map.forEach((ele) => (result = ele));
          // result = err;
          if (err.response.data?.message) {
            result = err.response.data?.message;
          }
        } else if (typeof err.response.data === "string") {
          result = err.response.data;
        }
        break;
      default:
        result = "Unknown Error";
        break;
    }
  }

  return result;
}
export function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}
